import React from 'react';
import './TextBaloon.css';

const TextBaloon = ({ number, text, color, textColor, arrowPosition = 'bottom' }) => {
  return (
    <div style={{ backgroundColor: color, color: textColor }} className="balloon">
      {arrowPosition === 'top' && <div style={{ borderBottom: `15px solid ${color}` }} className="arrow top"></div>}
      <div className="content">
        <span className="number">{number}</span>
        <span className="text">{text}</span>
      </div>
      {arrowPosition === 'bottom' && <div style={{ borderTop: `15px solid ${color}` }} className="arrow bottom"></div>}
    </div>
  );
};

export default TextBaloon;
